import script from "./customer-select.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-select.vue?vue&type=script&setup=true&lang=js"

import "./customer-select.vue?vue&type=style&index=0&id=f7a13000&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7a13000"]])

export default __exports__